import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { PlasseringAvEnhetIByggHorisontalt } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

export const HorisontalPlasseringRekkehusRadio = () => {
  const keyPrefix = 'register.bygningsdetaljer.rekkehus.plasseringAvEnhetIByggHorisontalt';
  const { register, formState } = useOmBoligenFormContext();
  const { t } = useTranslation('', { keyPrefix });

  const error = formState.errors.bygginfo?.horizontalPlacement?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('label')}</Fieldset.Legend>

      <Radio
        {...register('bygginfo.horizontalPlacement', {
          required: t('error'),
          shouldUnregister: true
        })}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.Enderekkehus}`)}
        value={PlasseringAvEnhetIByggHorisontalt.Enderekkehus}
        aria-invalid={!!error}
      />
      <Radio
        {...register('bygginfo.horizontalPlacement', {
          required: t('error'),
          shouldUnregister: true
        })}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.Midtrekkehus}`)}
        value={PlasseringAvEnhetIByggHorisontalt.Midtrekkehus}
        aria-invalid={!!error}
      />

      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
